import Pusher from 'pusher-js';

// Add a layer of indirection for creating pusher instances
// so we can spy on the constructor during testing and return a fake Pusher instance.
export default {
  createPusherInstance(key, authEndpoint) {
    return new Pusher(key, {
      authEndpoint: authEndpoint,
    });
  },
  enablePusherWithCredentials() {
    // Patch Pusher XMLHttpRequests to set the `withCredentials` flag for CORS auth requests.
    // Workaround adapted from here: https://github.com/pusher/pusher-js/issues/62
    Pusher.XHR = function createPusherHttpRequest() {
      let xhr = new window.XMLHttpRequest();
      xhr.withCredentials = true;
      return xhr;
    };
  },
  getPusher() {
    return Pusher;
  },
};
